import { Box } from '@mui/material';
import React from 'react';
import { ArrayField, Datagrid, FunctionField, TextField, useRecordContext } from 'react-admin';

import { EducationCenterType, HospitalDepartment } from 'src/components/Employees/types';
import { RaDatagridSimple } from 'src/Theme';
import { getValueOrPlaceholder } from 'src/utils';

const DepartmentsInfoTab: React.FC = () => {
    const records = useRecordContext<EducationCenterType>();

    if (!records) return null;

    const getHospitalDepartmentTypedRow = (rowData: any): HospitalDepartment => {
        return rowData as HospitalDepartment;
    };

    return (
        <ArrayField source="hospitalDepartments">
            <Datagrid bulkActionButtons={false} className={RaDatagridSimple}>
                <FunctionField
                    source="departmentName"
                    label="Назва відділеня"
                    render={(row: any) => (
                        <Box>{getValueOrPlaceholder(getHospitalDepartmentTypedRow(row)?.departmentName)}</Box>
                    )}
                />
                <FunctionField
                    source="hospitalName"
                    label="Назва лікарні"
                    render={(row: any) => (
                        <Box>{getValueOrPlaceholder(getHospitalDepartmentTypedRow(row)?.hospitalName)}</Box>
                    )}
                />
                {/* FIX temporary for columns width */}
                <TextField label="" source="" />
                <TextField label="" source="" />
                <TextField label="" source="" />
                <TextField label="" source="" />
                {/* FIX temporary for columns width */}
            </Datagrid>
        </ArrayField>
    );
};

export default DepartmentsInfoTab;
